module.exports = __webpack_public_path__ + "img/code_logo.f0aa8780.png";